import { styled as p } from "styled-components";
const a = p.span`
  ${({ theme: o }) => {
  var r, l;
  return (l = (r = o == null ? void 0 : o.get) == null ? void 0 : r.call(o, "tokens.helper.productive")) == null ? void 0 : l.toJS();
}}
`;
export {
  a as TableHeaderCellText
};
